import { Box, Skeleton } from '@mui/material';
import { PaperFrameStyled } from '@/components/common/paperFrameStyled';

const CashFlowAverageSpendingSkeleton: React.FC = () => {
  return (
    <PaperFrameStyled sx={{ flexGrow: 1 }}>
      <Box
        sx={{
          display: 'flex',
          padding: '24px',
          height: '100%',
          minHeight: 248,
        }}
      >
        <Skeleton
          variant='rectangular'
          width='100%'
          height='100%'
          sx={{ minHeight: 200, borderRadius: 1 }}
        />
      </Box>
    </PaperFrameStyled>
  );
};

export default CashFlowAverageSpendingSkeleton;
